/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
class ModalLgpd extends HTMLElement {
  get css() {
    return `
      :host {
        position: relative;
      }
      *, *::after, *::before{
          box-sizing: border-box;
      }
      .backdrop {
        position: fixed;
        display: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 99;
      }
      .active {
        display: block;
      }
      .modal {
        position: relative;
        top: 10%;
        overflow: auto;
        margin: auto;
        width: 75%;
        height: auto;
        max-width: 600px;
        min-width: 360px;
        max-height: 88%;
        z-index: 100;
        background-color: #fefefe;
        padding: 30px;
      }
      .header {
        background-color: #fefefe;
        color: #2D2926;
        border-radius: 10px 10px 0 0;
        z-index: 10;
      }
      .header h4 {
        font-style: normal;
        font-weight: 500;
        font-size: 26px;
        color: #005FC8;
      }
      .content p {
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 22px;
        color: #494949;
      }
      .footer {
        position: relative;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        bottom: 0;
        bottom: 0;
        width: 100%;
      }
      .btn {
        border: 1px #ddd solid;
        padding: 0.8em 1.5em;
        width: 70%;
        max-width: 250px;
        border: none;
        background-color: #005FC8;
        cursor: pointer;
        color: white;
      }
      .btn:hover {
        background-color: #005FC8;
        color: white;
      }
      .okBtn {
        font-size: 12px;
        font-weight: bold;
      }
      .fadeInDown {
        animation-name: fadeInDown;
        animation-duration: 0.35s;
        animation-fill-mode: both;
      }
      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-5%);
        }
        100% {
          opacity: 1;
          transform: translateY(0%);
        }
      }
      @media (max-width: 767px) {
        .modal {
          min-width: 88%;
          padding: 20px;
        }
        .footer {
          justify-content: center;
          align-items: center;
        }
        .btn {
          width: 100%;
        }
      }
    `;
  }

  constructor() {
    super();
    this._template = `
            <style>
              ${this.css} 
            </style>        
            <div class="backdrop">
                <div class="modal fadeInDown">
                    <div class="header">                  
                      <slot name="header">
                        <h4>Proteção dos seus dados</h4>
                      </slot>
                    </div>
                    <div class="content">
                      <slot name="content">
                        <p>
                          É importante saber que iremos coletar alguns dados seus,
                          eles servem para ativar, simular ou cotar os produtos em que você tem interesse.
                        </p>
                        <p>
                          Em algumas dessas ações, como cotar um produto, por exemplo, nós podemos usar
                          seus dados para te oferecer alguma oportunidade que combine com o seu perfil ou
                          até para tirar alguma dúvida.
                        </p>
                        <p>
                          Saiba mais detalhes de como utilizamos seus dados pessoais em nossa
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="http://caixasegurosholding.force.com/portalprivacidade">Política de Privacidade</a>.
                        </p>
                      </slot>
                    </div>
                    <div class="footer">
                        <slot name="footer">
                          <button id="btn" class="btn">
                            <span class="okBtn">Entendi</span>
                          </button>
                        </slot>
                    </div>
                </div>
            </div>
        `;
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.innerHTML = this._template;
  }

  static get observedAttributes() {
    return ["show"];
  }

  connectedCallback() {
    const confirmButton = this._shadowRoot.querySelector(".btn");
    confirmButton.addEventListener("click", (e) => {
      this.dispatchEvent(new CustomEvent("ok"));
      e.preventDefault();
    });
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (!this._shadowRoot.querySelector(".backdrop")) {
      return;
    }

    if (name === "show") {
      if ([true, "true"].includes(newVal)) {
        this._openModal();
      } else if ([false, "false"].includes(newVal)) {
        this._closeModal();
      }
    }
  }

  _openModal() {
    document.body.style.overflow = "hidden";
    this._shadowRoot.querySelector(".backdrop").classList.add("active");
  }

  _closeModal() {
    document.body.style.overflow = "unset";
    this._shadowRoot.querySelector(".backdrop").classList.remove("active");
  }
}

window.customElements.define("modal-lgpd", ModalLgpd);
